import { gaLabelSelector, newbuildingIdSelector } from '../selectors/newbuilding';
import { getNewbuildingExtra, getProductsData } from '../selectors/analytics';
import { useSelector } from 'react-redux';
import { trackCall } from '../analytics/call';
import { INewbuildingBuilder } from '../types/newbuilding/builder';

export const useCallAnalytics = () => {
  const gaLabel = useSelector(gaLabelSelector);
  const newbuildingId = useSelector(newbuildingIdSelector);
  const extra = useSelector(getNewbuildingExtra);

  const trackActionCall = (builder: INewbuildingBuilder | null) => {
    const analyticParams = {
      label: gaLabel,
      products: [getProductsData(newbuildingId, builder, extra)],
      modelVersion: '1',
    };
    const timerId = window.setTimeout(trackCall, 10000, analyticParams);
    /* istanbul ignore next */
    const onFocusListener = () => {
      clearTimeout(timerId);
    };

    window.addEventListener('focus', onFocusListener);
  };

  return {
    trackActionCall,
  };
};
